import { useIsMobile } from '@/hooks/useIsMobile';
import { Erx2Tab } from '@/pages/CarePlanView/Erx2Tab';
import { useControlBarClearance } from '@/pages/CarePlanView/useControlBarClearance';
import { createFileRoute } from '@tanstack/react-router';

const RouteComponent = (): React.ReactNode => {
  // oxlint-disable-next-line no-use-before-define
  const { patientId } = Route.useParams();
  const clearance = useControlBarClearance();
  const isMobile = useIsMobile();
  // Padded here, not in the tab: it is ScriptSure's iframe, so there is no scroller of ours to pad.
  return (
    <div className={`h-full min-h-0 ${isMobile ? '' : clearance}`}>
      <Erx2Tab patientId={patientId} />
    </div>
  );
};

export const Route = createFileRoute('/_auth/care-plan/$patientId/erx2')({
  component: RouteComponent,
});
